import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import {
  BellIcon,
  DesconnectionIcon,
  FrankIcon,
  FrankIconTwo,
  MailOrangeIcon,
  MyAnnounces,
  MyFaqs,
  PorteMonneiIcon,
  UserOrangeIcon,
} from "../../assets/images/FrankIcons";
import PropTypes from "prop-types";

import {
  AccountCircle,
  ArrowForwardIos,
  Close,
  ExitToApp,
  Help,
  KeyboardArrowDown,
  LocalActivity,
  Logout,
  Wallet,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import {
  Badge,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  clearAllDataFromLocalStorage,
  getDataFromLocalStorage,
  saveDataToLocalStorage,
} from "../../utils/LocalStore.util";
import drawerBoxIcon from "../../assets/mobileImages/drawer-box-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Store";
import { defaultLabelColors } from "../../utils/constants";
import moment from "moment";
import apiServices from "../../services/RequestHandler";
import { getAllNotifications } from "../../Store/MainAppReducer";
import { currencyFormat, numberFormatWithoutCurrencyFixed } from "../../utils/helper";
import Flogo from "../../assets/images/FrankIcons/Flogo.png"
import { ChevronRight } from "lucide-react";
import { useMediaQuery, useTheme } from "@mui/system";
import { Squircle } from "corner-smoothing";
const notifications = [
  {
    id: 1,
    text: "Livraison réussie ! 🎉 Vous recevez votre paiement bientôt.",
    date: "12/02/25 15:42",
    unread: true,
  },
  {
    id: 2,
    text: "🎉 Lilia Drias a accepté votre offre",
    date: "12/02/25 15:42",
    unread: true,
  },
  {
    id: 3,
    text: "🎉 Lilia Drias a accepté votre offre",
    date: "12/02/25 15:42",
    unread: false,
  },
];
function NewHeader(props:any) {
const dispatch = useDispatch<any>();
  const selector = useSelector((state: RootState) => state.mainApp);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [notifAnchor, setNotifAnchor] = useState<null | HTMLElement>(null);
  const [showNavbar, setShowNavbar] = useState(true);
  const lastScrollY = useRef(window.scrollY);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);


  const isNotifOpen = Boolean(notifAnchor);

  const theme = useTheme();
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
useEffect(() => {
  handleGetTransactionDetails()
}, [])

const handleGetTransactionDetails = async () => {
    try {
      if (userDetails) {
        
        const resp = await apiServices.getFromApi("c2c-wallets/wallet", "");
        let total_wallet = 0;
        for (const item of resp?.data) {
          if (
            item.transaction_type === "credit" &&
            item?.wallet_status_level === 1
          ) {
            total_wallet += item?.amount;
          } else {
            total_wallet -= item?.amount;
          }
        }
        setState({
          earnings: resp?.data ?? [],
          screen_loading: false,
          total_wallet,
        });
      }else{
      return
      }

    } catch (error) {
      console.log(error);
      setState({
        screen_loading: false,
      });
    }
  };





const { showContent,centeredLogo} = props;

const handleScroll = () => {
  const currentScrollY = window.scrollY;

  // Scrolling down
  if (currentScrollY > lastScrollY.current) {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setShowNavbar(false);
    }, 500);
  }

  // Scrolling up
  if (currentScrollY < lastScrollY.current) {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setShowNavbar(true);
  }

  lastScrollY.current = currentScrollY;
};

useEffect(() => {
  window.addEventListener('scroll', handleScroll);

  return () => {
    window.removeEventListener('scroll', handleScroll);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };
}, []);



  const openNotifDropdown = (event: React.MouseEvent<HTMLElement>) => {
    setNotifAnchor(event.currentTarget);
  };

  const closeNotifDropdown = () => {
    setNotifAnchor(null);
  };

  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      notifications: [],
      lang: "fr",
      notif_count: selector.notifications?.filter(
        (i: any) => i.is_read !== true
      ),
    }
  );

  useEffect(() => {
    setState({
      notifications: selector.notifications,
      refreshing: false,
    });
  }, [selector.notifications]);

  const toggleSideDrawer = (state: any) => () => {
    setDrawerOpen(state);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const handleLogout = () => {
    try {
      clearAllDataFromLocalStorage();
      toggleSideDrawer(false);
      navigate("/");
    } catch (error) {}
  };

  const toggleDrawer = (open: any) => (event: any) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const handlePressNotifiation = async (item: any) => {
    try {
      let resp = await apiServices.getFromApi(`/notifications/read/${item.id}`, "");
      dispatch(
        getAllNotifications({
          end_point: "/notifications/by-user",
        })
      )
      
      if (item.navigation_id === "messaging") {
        let obj: any = {
          id: Number(item?.nav_data?.ship_id),
          customer_id: Number(selector?.user?.id),
        };
        const resp = await apiServices.postFromApi(
          `c2c-shipments/details`,
          obj,
          ""
        );
        const details = resp?.data ?? {};
        
        if (resp?.data?.id) {
          // eslint-disable-next-line
          let receiver_id;
           let customer_id;
          if (`${item?.nav_data?.receiver?.id}` !== `${details?.customer_id}`) {
            customer_id = Number(item?.nav_data?.receiver?.id);
            receiver_id = Number(item?.nav_data?.sender?.id);
          } else {
            // eslint-disable-next-line
            customer_id = Number(item?.nav_data?.sender?.id);
            receiver_id = Number(item?.nav_data?.sender?.id);
          }
          navigate(`/chat/${details?.id}/${receiver_id}`);
        }
      } else {
        let obj: any = {
          id: Number(item?.nav_data?.ship_id),
          customer_id: Number(selector?.user?.id),
        };
        const resp = await apiServices.postFromApi(
          `c2c-shipments/details`,
          obj,
          ""
        );
        const details = resp?.data ?? {};
        
        if (item.nav_data?.ship_id || item.nav_data?.id) {
          if (item.navigation_id === "anouncement_details_sender") {
            navigate(`/my-activity`,{state: { ship_id:item.nav_data?.ship_id || item.nav_data?.id, tab_id: 0 }})
            // navigate(`/anounce/${item.nav_data?.ship_id || item.nav_data?.id}`);
            // navigate("/my-activity")
          } else if (item.navigation_id === "anouncement_details_transporter") {
            // navigate(`/job/${item.nav_data?.ship_id || item.nav_data?.id}`);
            // navigate("/my-activity")
            navigate(`/my-activity`,{state: { ship_id:item.nav_data?.ship_id || item.nav_data?.id, tab_id: 1 }})

          } else if (item.navigation_id === "send_parcel") {
            navigate(`/send-package`);
          } else if (item.navigation_id === "announcement_messaging") {
            
            navigate(`/chat/${details?.user_details?.id===userDetails?.id?0:1}/${item.nav_data?.ship_id || item.nav_data?.id}`);
          } else {
            navigate(
              `/${item.navigation_id}/${
                item.nav_data?.ship_id || item.nav_data?.id
              }`
            );
          }
        } else {
          if (item.navigation_id === "anouncement_details_sender") {
            navigate(`/my-activity/0/${item.nav_data?.ship_id || item.nav_data?.id}`)
            // navigate(`/anounce/${item.nav_data?.ship_id || item.nav_data?.id}`);
            // navigate("/my-activity")
          } else if (item.navigation_id === "anouncement_details_transporter") {
            // navigate(`/job/${item.nav_data?.ship_id || item.nav_data?.id}`);
            // navigate("/my-activity")
            navigate(`/my-activity/1/${item.nav_data?.ship_id || item.nav_data?.id}`)

          } else if (item.navigation_id === "announcement_messaging") {
            navigate(`/chat/1/${item.nav_data?.ship_id || item.nav_data?.id}`);
          } else if (item.navigation_id === "send_parcel") {
            navigate(`/send-package`);
          } else {
            navigate(
              `/${item.navigation_id}/${
                item.nav_data?.ship_id || item.nav_data?.id
              }`
            );
          }
        }
      }
      setNotifAnchor(null);
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();
 

  let userDetails = getDataFromLocalStorage("user");

  useEffect(() => {
    const notif_count = selector.notifications?.filter(
      (i: any) => i.is_read !== true
    );
    setState({
      notif_count,
    });
    // eslint-disable-next-line
  }, [JSON.stringify(selector.notifications)]);

  const [isScrolledUp, setIsScrolledUp] = useState(true);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
  
      if (scrollTop > lastScrollTop && scrollTop > 50) {
        // Scrolling down
        setIsScrolledUp(false);
      } else {
        // Scrolling up
        setIsScrolledUp(true);
      }
  
      setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop); // Avoid negative values
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollTop]);

  return (
    <div
      style={{
         
        display: "flex",
        justifyContent: "center",
        padding:'0px 16px'
      }}
    >
      <div
                                      
className={`glassmophoric ${isScrolledUp   ? 'active' : 'hidden'}`}
        style={{
          

          transition: "all 0.3s ease-in-out",
          borderRadius: 100,
          marginTop: 20,
          position: "fixed",
          zIndex: 1009,
          padding: screen_1024 ? "2px 24px" : "0px 20px ",
          display:'flex',
          paddingBottom:'2px',
          justifyContent: centeredLogo ? "center" : "space-between",
          // maxHeight:'66px',
          maxWidth: screen_1024 ? 738 :"90%",
          height: screen_1024 ? "76px" : "55px",
          border:"1px",
           width: screen_1024 ? '100%' : "100%",
           
           
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent:"space-between",
            left:"20px",
            top:'35px',
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              // justifyContent:'space-between'
            }}
          >
            <a href="/"   >
              {/* <FrankIconTwo /> */}
              <img src={Flogo} style={{height:32}} alt="" />
            </a>
          { showContent ?  
          <>
          <div
          className="hide-menu"
          style={{gap:48}}
           
            
            >
              <div className="font_resp" style={{fontSize:16}} >
                <div
                  className="menu-component menu-container"
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className="particulier font_resp"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Particulier{" "}
                    <KeyboardArrowDown
                      style={{ fontSize: "24px", fontWeight: "lighter" }}
                    />
                  </span>

                  <div className="dropdown">
                    <div
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/send-package");
                      }}
                    >
                      Envoyer un colis
                    </div>

                    <div
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/transporter-un-colis");
                      }}
                    >
                      Devenir transporteur
                    </div>
                    <div
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/relocation");
                      }}
                    >
                      Démenagement{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div className="font_resp">
                <div
                  className="menu-component menu-container"
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className="particulier font_resp"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Transporteur{" "}
                    <KeyboardArrowDown
                      style={{ fontSize: "24px", fontWeight: "lighter" }}
                    />{" "}
                  </span>

                  <div className="dropdown">
                    <div
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/transporter-un-colis");
                      }}
                    >
                      Devenir transporteur
                    </div>
                    <div
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/announces");
                      }}
                    >
                      Voir les annonces
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="font_resp">
                <div
                  className="menu-component menu-container"
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className="particulier font_resp"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => {
                      navigate("/blogs");
                    }}
                  >
                    Blog
                  </span>
                </div>
              </div> */}
            </div>

            <div
              className="hide_login_drawer"
              style={{ cursor: "pointer" ,position:'absolute',right:'25px' ,gap:6 ,placeItems:'center' }}
              onClick={toggleDrawer(true)}
            >
              <svg width="58" height="25" viewBox="0 0 58 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.26 16.5V8.1H2.244L6.012 14.448H5.484L9.204 8.1H10.188L10.2 16.5H9.048L9.036 9.912H9.312L6 15.48H5.448L2.112 9.912H2.412V16.5H1.26ZM15.3849 16.572C14.7049 16.572 14.1049 16.432 13.5849 16.152C13.0729 15.872 12.6729 15.488 12.3849 15C12.1049 14.512 11.9649 13.952 11.9649 13.32C11.9649 12.688 12.1009 12.128 12.3729 11.64C12.6529 11.152 13.0329 10.772 13.5129 10.5C14.0009 10.22 14.5489 10.08 15.1569 10.08C15.7729 10.08 16.3169 10.216 16.7889 10.488C17.2609 10.76 17.6289 11.144 17.8929 11.64C18.1649 12.128 18.3009 12.7 18.3009 13.356C18.3009 13.404 18.2969 13.46 18.2889 13.524C18.2889 13.588 18.2849 13.648 18.2769 13.704H12.8649V12.876H17.6769L17.2089 13.164C17.2169 12.756 17.1329 12.392 16.9569 12.072C16.7809 11.752 16.5369 11.504 16.2249 11.328C15.9209 11.144 15.5649 11.052 15.1569 11.052C14.7569 11.052 14.4009 11.144 14.0889 11.328C13.7769 11.504 13.5329 11.756 13.3569 12.084C13.1809 12.404 13.0929 12.772 13.0929 13.188V13.38C13.0929 13.804 13.1889 14.184 13.3809 14.52C13.5809 14.848 13.8569 15.104 14.2089 15.288C14.5609 15.472 14.9649 15.564 15.4209 15.564C15.7969 15.564 16.1369 15.5 16.4409 15.372C16.7529 15.244 17.0249 15.052 17.2569 14.796L17.8929 15.54C17.6049 15.876 17.2449 16.132 16.8129 16.308C16.3889 16.484 15.9129 16.572 15.3849 16.572ZM23.2966 10.08C23.8166 10.08 24.2726 10.18 24.6646 10.38C25.0646 10.58 25.3766 10.884 25.6006 11.292C25.8246 11.7 25.9366 12.216 25.9366 12.84V16.5H24.7846V12.972C24.7846 12.356 24.6326 11.892 24.3286 11.58C24.0326 11.268 23.6126 11.112 23.0686 11.112C22.6606 11.112 22.3046 11.192 22.0006 11.352C21.6966 11.512 21.4606 11.748 21.2926 12.06C21.1326 12.372 21.0526 12.76 21.0526 13.224V16.5H19.9006V10.14H21.0046V11.856L20.8246 11.4C21.0326 10.984 21.3526 10.66 21.7846 10.428C22.2166 10.196 22.7206 10.08 23.2966 10.08ZM30.7446 16.572C30.2006 16.572 29.7206 16.472 29.3046 16.272C28.8966 16.072 28.5766 15.768 28.3446 15.36C28.1206 14.944 28.0086 14.424 28.0086 13.8V10.14H29.1606V13.668C29.1606 14.292 29.3086 14.76 29.6046 15.072C29.9086 15.384 30.3326 15.54 30.8766 15.54C31.2766 15.54 31.6246 15.46 31.9206 15.3C32.2166 15.132 32.4446 14.892 32.6046 14.58C32.7646 14.26 32.8446 13.876 32.8446 13.428V10.14H33.9966V16.5H32.9046V14.784L33.0846 15.24C32.8766 15.664 32.5646 15.992 32.1486 16.224C31.7326 16.456 31.2646 16.572 30.7446 16.572Z" fill="black"/>
<path d="M44.6667 12.5H55.3334" stroke="black" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M44.6667 8.5H55.3334" stroke="black" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M44.6667 16.5H55.3334" stroke="black" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


            </div>
          
            <Drawer
              anchor="right"
              open={isDrawerOpen}
              onClose={toggleDrawer(false)}
              style={{
                borderRadius: "0px",
                background: "none",
                height: "100vh",
              }}
              PaperProps={{
                className: 'glassmorphic',
                  sx: {
                    width: "659px",
                    background: 'rgba(255, 255, 255, 0.95)',
                    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                    backdropFilter: 'blur(99%)',
                    WebkitBackdropFilter: 'blur(99%)',
                    border: '1px solid rgba(255, 255, 255, 0.95)',
                    color: '#fff',
                    borderRadius:"  24px ",
                    margin:"10px",
                    height:"98vh"
                  },
              }}
            >
              <div style={{ display: "flex",background:'#fff',justifyContent:'center',alignItems:'center',padding:"2px 20px" }}>
                <div style={{ flex: 1,paddingTop:"10px" }}>
                  <FrankIcon fill={"#ee6931"} height={40} />
                </div>
                <div >
                  <p style={{fontFamily:'montserrat-Medium',fontSize:'14px',color:'#000',margin:0,cursor:'pointer'}} onClick={toggleDrawer(false)}>Fermer</p>
                 
                </div>
              </div>
              <Typography
                variant="body1"
                style={{  flex: 1,paddingTop:"10px" }}
              >
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 20 }}
                >
                  {/* {userDetails ? (
                    <div className="user" style={{ cursor: "pointer" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                          fontFamily: "Raleway-Variable",
                          fontWeight: "600",
                        }}
                        onClick={() => {
                          navigate("chat");
                        }}
                      >
                        <span style={{ color: "#000" }}>Mail</span>
                      </div>
                    </div>
                  ) : null} */}

                  {userDetails ? (
                   <>
                      <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box>

        <List disablePadding style={{ rowGap:20}}>
            <ListItemButton
            style={{margin:0 }}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#000"}
                  >
                    Particulier
                   </Typography>
                }
              />
            </ListItemButton>
            <ListItemButton
            onClick={()=>{navigate("/send-package")}}
            style={{margin:0,display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer'}}
            >
         
              <ListItemText
              style={{margin:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-Regular"
                    fontSize="18px"
                    color={"#000"}
                  >
                    Envoyer un colis
                   </Typography>
                }
              />
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 13L7 7L0.999999 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


            </ListItemButton>
            <ListItemButton
            style={{margin:0,display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer'}}
            onClick={()=>{navigate("/relocation")}}
            >
         
              <ListItemText
              style={{margin:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-Regular"
                    fontSize="18px"
                    color={"#000"}
                  >
                    Démenagement
                   </Typography>
                }
              />
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 13L7 7L0.999999 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


            </ListItemButton>
            <ListItemButton
            style={{margin:0 }}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#000"}
                  >
                    Transporteur
                   </Typography>
                }
              />
            </ListItemButton>
            <ListItemButton
            style={{margin:0,display:'flex',cursor:'pointer',justifyContent:'space-between',alignItems:'center'}}
            onClick={()=>{navigate("/transporter-un-colis")}}

            >
         
              <ListItemText
              style={{margin:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-Regular"
                    fontSize="18px"
                    color={"#000"}
                  >
                    Devenir transporteur
                   </Typography>
                }
              />
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 13L7 7L0.999999 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


            </ListItemButton>
            <ListItemButton
            style={{margin:0,display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer'}}
            onClick={()=>{navigate("/announces")}}

            >
         
              <ListItemText
              style={{margin:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-Regular"
                    fontSize="18px"
                    color={"#000"}
                  >
                    Voir les annonces
                   </Typography>
                }
              />
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 13L7 7L0.999999 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


            </ListItemButton>

            <ListItemButton
            style={{margin:0,marginTop:20  }}
            onClick={()=>{navigate("/notifications")}}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#000"}
                  >
                    Notifications
                   </Typography>
                }
              />
               <div
                          style={{
                            height: 25,
                            width: 25,
                            borderRadius: 100,
                            // display:'flex',
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#FF3B30",
                            display:
                              state?.notif_count?.length < 1 ? "none" : "flex",
                          }}
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontFamily: "montserrat-SemiBold",
                              fontSize: 11,
                            }}
                          >
                            {state?.notif_count?.length > 99
                              ? "99+"
                              : state?.notif_count?.length}
                          </span>
                        </div>
            </ListItemButton>
            <ListItemButton
            style={{margin:0  }}
            onClick={()=>{navigate("/chat")}}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#000"}
                  >
                    Messages
                   </Typography>
                }
              />
            </ListItemButton>

            <ListItemButton
            style={{margin:0  }}
            onClick={()=>{navigate("/profile")}}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#000"}
                  >
                    Profil
                   </Typography>
                }
              />
            </ListItemButton>

            <ListItemButton
            style={{margin:0  }}
            onClick={()=>{navigate("/wallet")}}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#000"}
                  >
                    Porte monnaie
                   </Typography>
                }
              />
            </ListItemButton>


            <ListItemButton
            style={{margin:0  }}
            onClick={()=>{navigate("/my-activity")}}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#000"}
                  >
                    Mes activités
                   </Typography>
                }
              />
            </ListItemButton>

            <ListItemButton
            style={{margin:0  }}
            onClick={()=>{navigate("/faq")}}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#000"}
                  >
                    FAQ
                   </Typography>
                }
              />
            </ListItemButton>

            <ListItemButton
            style={{margin:0  }}
            onClick={handleLogout}
            >
         
              <ListItemText
              style={{margin:0,padding:0}}
                primary={
                  <Typography
                    fontFamily="montserrat-SemiBold"
                    fontSize="16px"
                    color={"#FF3B30"}
                  >
                    Deconnexion
                   </Typography>
                }
              />
            </ListItemButton>
         
        </List>
      </Box>

      
    </Box>
                   </>
                  ) : (
                    // <div
                    //   className="menu-component menu-container"
                    //   style={{ cursor: "pointer" }}
                    //   onClick={() => {
                    //     navigate("/login");
                    //   }}
                    // >
                    //   <span
                    //     className="particulier font_resp"
                    //     style={{
                    //       display: "flex",
                    //       justifyContent: "center",
                    //       alignItems: "center",
                    //       fontFamily: "montserrat-SemiBold",
                    //       gap: 10,
                    //     }}
                    //   >
                    //     Se connecter{" "}
                    //   </span>
                    // </div>
                    <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                    }}
                  >
                    <Box>
              
                      <List disablePadding style={{ rowGap:20}}>
                          <ListItemButton
                          style={{margin:0 }}
                          >
                       
                            <ListItemText
                            style={{margin:0,padding:0}}
                              primary={
                                <Typography
                                  fontFamily="montserrat-SemiBold"
                                  fontSize="16px"
                                  color={"#000"}
                                >
                                  Particulier
                                 </Typography>
                              }
                            />
                          </ListItemButton>
                          <ListItemButton
                          onClick={()=>{navigate("/send-package")}}
                          style={{margin:0,display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer'}}
                          >
                       
                            <ListItemText
                            style={{margin:0}}
                              primary={
                                <Typography
                                  fontFamily="montserrat-Regular"
                                  fontSize="18px"
                                  color={"#000"}
                                >
                                  Envoyer un colis
                                 </Typography>
                              }
                            />
                              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 13L7 7L0.999999 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
              
                          </ListItemButton>
                          <ListItemButton
                          style={{margin:0,display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer'}}
                          onClick={()=>{navigate("/relocation")}}
                          >
                       
                            <ListItemText
                            style={{margin:0}}
                              primary={
                                <Typography
                                  fontFamily="montserrat-Regular"
                                  fontSize="18px"
                                  color={"#000"}
                                >
                                  Démenagement
                                 </Typography>
                              }
                            />
                              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 13L7 7L0.999999 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
              
                          </ListItemButton>
                          <ListItemButton
                          style={{margin:0 }}
                          >
                       
                            <ListItemText
                            style={{margin:0,padding:0}}
                              primary={
                                <Typography
                                  fontFamily="montserrat-SemiBold"
                                  fontSize="16px"
                                  color={"#000"}
                                >
                                  Transporteur
                                 </Typography>
                              }
                            />
                          </ListItemButton>
                          <ListItemButton
                          style={{margin:0,display:'flex',cursor:'pointer',justifyContent:'space-between',alignItems:'center'}}
                          onClick={()=>{navigate("/transporter-un-colis")}}
              
                          >
                       
                            <ListItemText
                            style={{margin:0}}
                              primary={
                                <Typography
                                  fontFamily="montserrat-Regular"
                                  fontSize="18px"
                                  color={"#000"}
                                >
                                  Devenir transporteur
                                 </Typography>
                              }
                            />
                              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 13L7 7L0.999999 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
              
                          </ListItemButton>
                          <ListItemButton
                          style={{margin:0,display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer'}}
                          onClick={()=>{navigate("/announces")}}
              
                          >
                       
                            <ListItemText
                            style={{margin:0}}
                              primary={
                                <Typography
                                  fontFamily="montserrat-Regular"
                                  fontSize="18px"
                                  color={"#000"}
                                >
                                  Voir les annonces
                                 </Typography>
                              }
                            />
                              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 13L7 7L0.999999 1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
              
                          </ListItemButton>
              
                          <ListItemButton
                          style={{margin:0,marginTop:20  }}
                          onClick={() => {
                                navigate("/login");
                              }}
                          >
                       
                            <ListItemText
                            style={{margin:0,padding:0}}
                              primary={
                                <Typography
                                  fontFamily="montserrat-SemiBold"
                                  fontSize="16px"
                                  color={"#000"}
                                >
                                  Se connecter
                                 </Typography>
                              }
                            />
                             
                          </ListItemButton>
                           
              
                        
              
                         
              
              
                         
              
                          
              
                         
                       
                      </List>
                    </Box>
              
                    
                  </Box>
                  )}
                </div>
              </Typography>
             
            </Drawer>

            <div className="login_area">
              <div className="right" style={{ justifyContent: "flex-end",gap:'24px' }}>
                {userDetails ? (
                 
                  <div className="tracker" style={{ cursor: "pointer" }}>
                  <IconButton onClick={openNotifDropdown}>
                  
                      <div
                        style={{
                          position: "relative",
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                      >
                        <BellIcon
                         />
                        <div
                          style={{
                            position: "absolute",
                            right: -10,
                            top: -10,
                            height: 20,
                            width: 20,
                            borderRadius: 100,
                            // display:'flex',
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#FF3B30",
                            display:
                              state?.notif_count?.length < 1 ? "none" : "flex",
                          }}
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontFamily: "Raleway-Semi-Bold",
                              fontSize: 10,
                            }}
                          >
                            {state?.notif_count?.length > 99
                              ? "99+"
                              : state?.notif_count?.length}
                          </span>
                        </div>
                      </div>
                  </IconButton>
            
                  <Menu
  anchorEl={notifAnchor}
  open={isNotifOpen}
  onClose={closeNotifDropdown}
  PaperProps={{
    style: {
      width: "300px",
           borderRadius: "0px 12px 12px 12px",
      padding: "10px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
       
      overflow: "hidden", // prevent scrollbar from cutting borderRadius
    },
  }}
>
  <Typography
    variant="h6"
    sx={{ px: 2, pb: 1, color: "#333", fontFamily: "montserrat-Bold",paddingLeft:'0px' }}
  >
    Notifications
  </Typography>

  <Box
    sx={{
      maxHeight: 400,
      overflowY: "auto",
    }}
  >
   {state.notifications?.map((item: any, index: number) => (
  <MenuItem
    key={item.id}
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "4px",
      py: "14px",
      px: "6px",
      borderBottom: "1px solid #eee",
      whiteSpace: "normal", // allows wrapping
    }}
    onClick={() => handlePressNotifiation(item)}
  >
    <Box display="flex" alignItems="center" width="100%">
      <Typography
        variant="body2"
        sx={{
          flex: 1,
          color: "#666",
          fontFamily: "montserrat-Regular",
          wordBreak: "break-word", // ensures long words wrap
          fontSize:'16px'
        }}
      >
        {item.notif_body?.fr}
      </Typography>
      <div style={{ display: "flex", flexDirection: "column", marginLeft: 8 }}>
        {!item.is_read && (
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "100%",
              backgroundColor: "#ff3b30",
              ml: 1,
              display: "block",
            }}
          />
        )}
        <ChevronRight style={{ height: 24, width: 24, color: "#BCBBC4" }} />
      </div>
    </Box>
    <Typography
      variant="caption"
      sx={{
        color: "#000",
        fontSize: "12px",
        fontFamily: "montserrat-Regular",
        whiteSpace: "nowrap",
      }}
    >
      {moment(item?.created_at_tz).format("DD/MM/YY HH:mm")}
    </Typography>
  </MenuItem>
))}

  </Box>
</Menu>

                </div>
                ) : null}

                {userDetails ? (
                  <div
                    className="tracker"
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft:5,
                      paddingRight:'-10px'
                    }}
                  >
                    <div
                      className="line-mail"
                      style={{ display: "flex", alignItems: "center" }}
                      onClick={() => {
                        navigate("/chat");
                      }}
                    >
                      <MailOrangeIcon />
                    </div>
                  </div>
                ) : null}

                {userDetails ? (
                  <div
                    className="compte"
                    style={{ cursor: "pointer", position: "relative" }}
                  >
                    <div className="user" style={{}}>
                      <div
                        style={{ display: "flex", alignItems: "flex-end" }}
                        // onClick={() => {
                        //   handleVerticalTabChangeForProfile();
                        //   navigate("/profile");
                        // }}
                        onClick={toggleSideDrawer(true)}
                      >
                        <UserOrangeIcon />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="menu-component menu-container"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    <span
                      className="particulier font_resp"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontFamily: "montserrat-SemiBold",
                        gap: 10,
                      }}
                    >
                      Se connecter{" "}
                    </span>
                  </div>
                )}

                <Drawer
                  anchor="right"
                  open={drawerOpen}
                  onClose={toggleSideDrawer(false)}
                  PaperProps={{
                    sx: {
                      width: 353, // Adjust width to match your design
                      padding: "24px",
                      borderRadius: "16px 0 0 16px",
                      paddingRight: "5px",
                    },
                  }}
                >
                  <Box
                    sx={{
                      // width: 330,
                      display: "flex",
                      flexDirection: "column",
                     }}
                    role="presentation"
                    onClick={toggleSideDrawer(false)}
                    onKeyDown={toggleSideDrawer(false)}
                  >
                    {/* Logo and Close Icon */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <FrankIcon fill={"#ee6931"} height={65} width={124} />
                      
                       {/* <img src={Flogo} style={{height:65,width:124}} alt="" /> */}
                      <IconButton onClick={toggleSideDrawer(false)} style={{marginTop:-10}}>
                        <Close />
                      </IconButton>
                    </Box>
                    <Divider />

                    {/* Menu Items */}
                    <List
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 20,
                        marginLeft: "-12px",
                        marginTop:'10px'
                      }}
                    >
                      <ListItem
                        style={{ cursor: "pointer",padding:0 }}
                        onClick={() => {
                          navigate("/profile");
                        }}
                      >
                        <ListItemIcon
                          style={{ display: "flex", alignItems: "flex-start",justifyContent:'center',marginBottom:10 }}
                        >
                          <UserOrangeIcon height={24} width={24} />
                        </ListItemIcon>
                        <div>
                          <p
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              margin: 0,
                              fontSize: 16,
                              color: defaultLabelColors.main_font,
                            }}
                          >
                            Profil
                          </p>
                          <p
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              margin: 0,
                              fontSize: 16,
                              color: "#78778A",
                            }}
                          >
                           
                            {userDetails?.idenfy_verification ? userDetails?.email : <span style={{color:'red'}}> Veuillez vérifier votre profil </span> }
                          </p>
                        </div>
                      </ListItem>

                      <ListItem style={{cursor:'pointer',padding:0 }} onClick={()=>{navigate("/wallet")}}>
                      <ListItemIcon
                          style={{ display: "flex", alignItems: "flex-start",justifyContent:'center',marginBottom:10 }}
                        >                          <PorteMonneiIcon height={24} width={24} />
                        </ListItemIcon>
                        <div>
                          <p
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              margin: 0,
                              fontSize: 16,
                              color: defaultLabelColors.main_font,
                            }}
                          >
                            Porte monnaie
                          </p>
                          <p
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              margin: 0,
                              fontSize: 16,
                              color: "#78778A",
                            }}
                          >
                            { state?.total_wallet ? currencyFormat(state?.total_wallet?.toFixed(2)) : "0,00"}€
                          </p>
                        </div>
                      </ListItem>

                      <ListItem style={{cursor:'pointer',padding:0}} onClick={()=>{navigate("/my-activity")}}>
                      <ListItemIcon
                          style={{ display: "flex", alignItems: "flex-start",justifyContent:'center',marginBottom:10 }}
                        >                             <UserOrangeIcon />
                        </ListItemIcon>
                        <div style={{cursor:'pointer'}} onClick={()=>{navigate("/my-activity")}}>
                          <p
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              margin: 0,
                              fontSize: 16,
                              color: defaultLabelColors.main_font,
                            }}
                          >
                            Mes activités
                          </p>
                        </div>{" "}
                      </ListItem>

                      <ListItem onClick={()=>{navigate("/announces")}} style={{ cursor: "pointer",padding:0,marginTop:5 }}>
                      <ListItemIcon
                          style={{ display: "flex", alignItems: "flex-start",justifyContent:'center'  }}
                        >                             <MyAnnounces />
                        </ListItemIcon>
                        <div>
                          <p
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              margin: 0,
                              fontSize: 16,
                              color: defaultLabelColors.main_font,
                            }}
                          >
                            Voir les annonces
                          </p>
                        </div>{" "}
                      </ListItem>

                      <ListItem onClick={()=>{navigate("/faq")}} style={{ cursor: "pointer",padding:0,marginTop:"5px" }}>
                      <ListItemIcon
                          style={{ display: "flex", alignItems: "flex-start",justifyContent:'center' }}
                        >                             <MyFaqs />
                        </ListItemIcon>
                        <div>
                          <p
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              margin: 0,
                              fontSize: 16,
                              color: defaultLabelColors.main_font,
                            }}
                          >
                            FAQ
                          </p>
                        </div>{" "}
                      </ListItem>
                    </List>

                    {/* Logout */}
                    <ListItem
                      sx={{ color: "red", cursor: "pointer",padding:0,marginLeft:"-12px",marginTop:"15px" }}
                      onClick={handleLogout}
                    >
  <ListItemIcon
                          style={{ display: "flex", alignItems: "flex-start",justifyContent:'center'  }}
                        >                           <DesconnectionIcon />
                      </ListItemIcon>
                      <div>
                        <p
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            margin: 0,
                            fontSize: 16,
                            color: "#FF3B30",
                          }}
                        >
                          Déconnexion
                        </p>
                      </div>{" "}
                    </ListItem>
                  </Box>
                </Drawer>
              </div>
            </div> </> : null}

          </div>
        </div>
      </div>
    </div>
  );
}

NewHeader.defaultProps = {
  showContent: true,
  centeredLogo:false}

  NewHeader.propTypes = {
  value: PropTypes.any}

export default NewHeader;
